import { useLayoutEffect } from 'react'

interface MainProps {
  children?: React.ReactNode
}

function Main ({ children }: MainProps) {
  return (
    <main className='grow bg-gray-50 pt-14 md:pt-0 md:ml-60'>
      <div className='mx-auto max-w-7xl pt-6 md:pt-8 pb-20 px-4 md:px-12 min-h-full flex flex-col'>
        {children}
      </div>
    </main>
  )
}

Main.displayName = 'DashboardLayout.Main'

interface SidebarProps {
  children?: React.ReactNode;
}

function Sidebar ({ children }: SidebarProps) {
  return (
    <div className='fixed left-0 top-0 bottom-0 w-60 bg-gray-100 border-r border-gray-200'>
      {children}
    </div>
  )
}

Sidebar.displayName = 'DashboardLayout.Sidebar'

interface MobileNavBarProps {
  children?: React.ReactNode;
}

function MobileNavBar ({ children }: MobileNavBarProps) {
  return (
    <div className='fixed top-0 left-0 right-0 h-14 shadow backdrop-blur-xl z-10'>
      {children}
    </div>
  )
}

MobileNavBar.displayName = 'DashboardLayout.MobileNavBar'

interface DashboardLayoutProps {
  children?: React.ReactNode;
}

export function DashboardLayout ({ children }: DashboardLayoutProps) {
  useLayoutEffect(() => {
    document.body.setAttribute('data-page-loaded', '')
  }, [])

  return (
    <div className='min-h-svh isolate flex'>
      {children}
    </div>
  )
}

DashboardLayout.Main = Main
DashboardLayout.MobileNavBar = MobileNavBar
DashboardLayout.Sidebar = Sidebar
